import React, { useEffect, useState } from 'react'
import {
    ButtonHLPure,
    InputHLPure,
    DataPickerHLPure,
    DropDownBtnHLPure,
    TextAreaHLPure,
    Traslates,
    LabelHLPure
} from '../../pures'
import styles from './assemblies-add-detail.module.css'
import { AssembliesService, LocalStorageService } from '../../../services'
import moment from 'moment'
import TimePickerGD from '../../pures/timePicker/TimePickerGD'
import { DateTime } from 'luxon'
import { NIL as NIL_UUID } from 'uuid'

const AssembliesAddDetailView = (props) => {
    let {
        t,
        assemblySelected,
        changePage,
        companies,
        showErrorNoCompanies,
        nameComponent
    } = props

    let assemblyDefault = {
        name: '',
        companyAssemblyId: NIL_UUID,
        date: new Date(),
        time: new Date(),
        location: '',
        objective: '',
        notes: ''
    }

    const [assembly, setAssembly] = useState(assemblyDefault)

    const label = assembly.id ? t('assembliesAction.btn.reschedule') : t('assembliesAction.btn.schedule')
    const timezone = LocalStorageService.retrieveItem('timezone')

    const actionAssembly = async () => {
        props.toggleLoadingRequesting(true)
        const token = LocalStorageService.retrieveToken()
        const assemblyToSend = { ...assembly }
        assemblyToSend.date = DateTime.fromJSDate(assembly.date).toFormat('yyyy-MM-dd')
        assemblyToSend.time = DateTime.fromJSDate(assembly.time, { zone: timezone }).toFormat('HH:mm:ss ZZZZ')

        try {
            if (assembly.id) {
                assemblyToSend.assemblyId = assembly.id
                const assemblyUpdated = await AssembliesService.updateAssembly(assemblyToSend, token)
                if (assemblyUpdated.statusCode === 200) {
                    props.toggleLoadingRequesting(false)
                    props.toggleCompletedRequesting(3000, false, null)
                    setTimeout(async () => {
                        await props.getAssemblies()
                        changePage('principal', t('assembliesAction.header.title'))
                    }, 3000)
                } else throw new Error()
            } else {
                const assemblyCreated = await AssembliesService.createAssembly(assemblyToSend, token)
                if (assemblyCreated.statusCode === 200) {
                    props.toggleLoadingRequesting(false)
                    props.toggleCompletedRequesting(3000, false, null)
                    setTimeout(async () => {
                        await props.getAssemblies()
                        changePage('principal', t('assembliesAction.header.title'))
                    }, 3000)
                } else throw new Error()
            }
        } catch (e) {
            props.toggleLoadingRequesting(false)
            props.toggleErrorRequesting('', 3000)
        }

    }

    const changeValue = (event, key) => setAssembly({ ...assembly, [key]: event.target.value })


    useEffect(() => {
        const isDetailComponent = nameComponent === process.env.REACT_APP_NAME_COMPONENT_DETAIL
        let assemblyData = {
            id: isDetailComponent && assemblySelected && assemblySelected.id ? assemblySelected.id : null,
            name: isDetailComponent ? assemblySelected.name : assemblyDefault.name,
            companyAssemblyId: isDetailComponent ? assemblySelected.companyAssemblyId : (companies[0] && companies[0].id) ? companies[0].id : assemblyDefault.companyAssemblyId,
            date: isDetailComponent ? DateTime.fromSQL(assemblySelected.date).setZone(timezone).toJSDate() : assemblyDefault.date,
            time: isDetailComponent ? DateTime.fromSQL(`${assemblySelected.date} ${assemblySelected.time}`).toJSDate() : assemblyDefault.time,
            location: isDetailComponent ? assemblySelected.location : assemblyDefault.location,
            objective: isDetailComponent ? assemblySelected.objective : assemblyDefault.objective,
            notes: isDetailComponent ? assemblySelected.notes : assemblyDefault.notes
        }
        setAssembly(assemblyData)
    }, [companies])

    useEffect(() => {
        if (showErrorNoCompanies) {
            props.toggleLoadingRequesting(false)
            props.toggleErrorRequesting(t('assembliesAction.errors.no.companies'), 4000)
            setTimeout(() => {
                changePage('principal', t('assembliesAction.header.title'))
                props.setAssemblySelected({})
            }, 4000)
        }
    }, [showErrorNoCompanies])
    return (
        <div className={styles['assembly_body']}>
            <div className={styles['assembly_container']}>
                <div className={styles['assembly_elements']}>
                    <DropDownBtnHLPure
                        labelDropDown={t('assembliesAddUpdateView.assignedCompany.label')}
                        nameOption='companyName'
                        valueItem='id'
                        onDropDownChange={(e) => changeValue(e, 'companyAssigned')}
                        optionsDropDown={companies}
                    />
                    <InputHLPure
                        labelInput={t('assembliesAddUpdateView.assemblyName.label')}
                        valueInput={assembly.name}
                        inputActive
                        handleChangeInput={(e) => changeValue(e, 'name')}
                    />
                    <InputHLPure
                        labelInput={t('assembliesAddUpdateView.assemblyLocation.label')}
                        valueInput={assembly.location}
                        inputActive
                        handleChangeInput={(e) => changeValue(e, 'location')}
                    />
                    <hr className='line-section' />
                    <TextAreaHLPure
                        labelTextArea={t('assembliesAddUpdateView.assemblyObjective.label')}
                        style={{ minHeight: 60 }}
                        characterLimit={2000}
                        valueTextData={assembly.objective}
                        rowsTextArea={5}
                        handleChangeTextArea={(e) => changeValue(e, 'objective')}
                    />
                    <TextAreaHLPure
                        labelTextArea={t('assembliesAddUpdateView.assemblyNotes.label')}
                        style={{ minHeight: 60 }}
                        characterLimit={2000}
                        valueTextData={assembly.notes}
                        rowsTextArea={5}
                        handleChangeTextArea={(e) => changeValue(e, 'notes')}
                    />
                    <hr className='line-section' />
                    <div className={styles['assembly_date']}>
                        <Traslates>
                            <DataPickerHLPure
                                labelDataPicker={t('assembliesAddUpdateView.assemblyDate.label')}
                                valueDate={assembly.date}
                                handleChangeDate={(e) => changeValue(e, 'date')}
                            />
                        </Traslates>
                        <Traslates>
                            <TimePickerGD
                                textLabel='Hora de la asamblea'
                                className={styles['']}
                                steps={{ minute: 5 }}
                                onChange={(e) => changeValue(e, 'time')}
                                timeState={assembly.time}
                            />
                        </Traslates>
                    </div>
                </div>
                <div className={styles['assembly_buttons']}>
                    <ButtonHLPure
                        nameBtn={t('button.back')}
                        primary={false}
                        onClickBtn={() => {
                            changePage('principal', t('assembliesAction.header.title'))
                            props.setAssemblySelected({})
                        }}
                    />
                    <ButtonHLPure
                        nameBtn={label}
                        primary
                        onClickBtn={actionAssembly}
                    />
                </div>
            </div>
        </div>
    )
}

export { AssembliesAddDetailView as default }